import { atom } from 'recoil';

export const LoginUser = atom({
  key: 'LoginUser',
  default: {
    role: '',
  },
});
